<script setup>
import Chart from './Trend.vue'
import CoinIntro from '../CurrencyIntro.vue'

const { t } = useI18n()
const tabs = computed(() => [
  { key: 'Chart', title: t('图表'), component: Chart },
  { key: 'CoinIntro', title: t('币种概况'), component: CoinIntro },
])
</script>

<template>
  <div class="w-full h-full flex-1 bg-fillPagePrimary">
    <common-x-mod :tabs="tabs" header-class="h-9 !px-3" class="h-full" component-class="!px-0" />
  </div>
</template>
